<template>
  <div id="app">
    <div class="appWrapper" v-if="$route.meta.keepAlive">
      <topbar></topbar>
      <leftbar></leftbar>
      <router-view />
    </div>
    <div v-if="!$route.meta.keepAlive">
      <router-view />
    </div>
  </div>
</template>

<script>
	import topbar from '@/components/topBar.vue'
	import leftbar from '@/components/leftBar.vue'
export default {
  name: 'App',
  components: {
    topbar: topbar,
    leftbar: leftbar
  }
}
</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease-out;
  }
  
  .fade-enter,
  .fade-leave-to
  
  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue